import React from 'react';
import {IonIcon} from '@ionic/react';
import {shieldCheckmarkSharp} from 'ionicons/icons';
import {Line} from 'react-chartjs-2';

import Panel from "../ui/Panel";
import {lineChart, chartColors} from "../Graphs/chartTheme";
import "./CardParts.css";

interface SafetyCardProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  newdata: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: any;
}

/**
 * Fatal crashes by year, with the exposure-adjusted rate beside it.
 *
 * A count alone cannot say whether roads got safer, only whether more was
 * driven on them, so the rate per 100M vehicle-miles sits next to it.
 */
const SafetyCard: React.FC<SafetyCardProps> = (props: SafetyCardProps) => {
  const years: string[] = props.newdata.fatalitiesYears ?? [];
  const fatalities: number[] = props.newdata.fatalitiesByYear ?? [];
  if (years.length === 0) {
    return null;
  }

  const chart = lineChart(years, fatalities, 'Fatal crashes',
    chartColors.domain('crashes', '#2a78d6'));

  return (
    <Panel
      title="Fatal crashes by year"
      subtitle={`${years[years.length - 1]} is a part year`}
      accent="var(--domain-crashes)"
      icon={<IonIcon icon={shieldCheckmarkSharp} />}
      footer={`Updated ${props.content.updated}`}
    >
      <dl className="stat-pair">
        <div className="stat-pair__item">
          <dt>Crash rate</dt>
          <dd>{props.newdata.crashRate?.value ?? '-'}</dd>
        </div>
        <div className="stat-pair__item">
          <dt>Fatal rate</dt>
          <dd>{props.newdata.fatalRate?.value ?? '-'}</dd>
        </div>
        <div className="stat-pair__item">
          <dt>Daily VMT</dt>
          <dd>{((props.newdata.vmtDaily?.value ?? 0) / 1e6).toFixed(0)}M</dd>
        </div>
      </dl>
      <p className="card-note">
        Rates are per 100 million vehicle-miles on the monitored corridors, so
        they compare with each other over time rather than with a statewide
        figure.
      </p>
      <div className="chart-frame">
        <Line data={chart.data} options={chart.options} />
      </div>
    </Panel>
  );
};

export default SafetyCard;
